import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=6c3c7734&"
import script from "./ModalWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports